import { v4 as uuidv4 } from 'uuid';
import { db, timeStamp, arrayUnion } from '../firebase/firebase.config.js';
import selectedMonth from './selectedMonth.js';




const handleFunds = (data, uid, BankStore) => {

    return new Promise ((resolve, reject) => {

        const { fundsAmount, fundsProvider, fundsDate, selectedBank} = data;
        let currentTimeStamp;
        let selectedYear;
        
        const uuid = uuidv4();
        const uidBanks = db.collection(uid).doc('banks');
        const banksHistory = uidBanks.collection('history');
        let latestTotalAmount;
        let lastTotalAmount;

        let fundsDateVal = new Date( fundsDate );
        selectedYear = fundsDateVal.getFullYear();
        let selectedMnth = selectedMonth(fundsDateVal.getMonth());



        

        const updateSelectedMonthsHistory = (currentTimeStamp) => {
            banksHistory.doc(`year${selectedYear}`).update({
                [`${selectedMnth}.daysList`]: arrayUnion(fundsDateVal),
                [`${selectedMnth}.recordsList`]: arrayUnion(
                    {
                        recordId: uuid,
                        fundsAmount: fundsAmount,
                        fundsProvider: fundsProvider,
                        selectedBank: selectedBank,
                        fundsDate: fundsDateVal,
                        timeStamp: currentTimeStamp
                    }
                )
            })
            .then(() => {
                resolve({
                    dataSaved: true
                });
            });
        };

        const createNewMonthsHistory = (currentTimeStamp) => {
            banksHistory.doc(`year${selectedYear}`).update({
                monthsList: arrayUnion(`${selectedMnth}`),
                [`${selectedMnth}`]: {
                    daysList: [fundsDateVal],
                    recordsList: [
                        {
                            recordId: uuid,
                            fundsAmount: fundsAmount,
                            fundsProvider: fundsProvider,
                            selectedBank: selectedBank,
                            fundsDate: fundsDateVal,
                            timeStamp: currentTimeStamp
                        }
                    ]
                }
            })
            .then(() => {
                resolve({
                    dataSaved: true
                });
            });
        };

        const createNewYearsHistory = (currentTimeStamp) => {
            banksHistory.doc(`year${selectedYear}`).set({
                monthsList: [`${selectedMnth}`],
                [`${selectedMnth}`]: {
                    daysList: [fundsDateVal],
                    recordsList: [
                        {
                            recordId: uuid,
                            fundsAmount: fundsAmount,
                            fundsProvider: fundsProvider,
                            selectedBank: selectedBank,
                            fundsDate: fundsDateVal,
                            timeStamp: currentTimeStamp
                        }
                    ]
                }
            })
            .then(() => {
                resolve({
                    dataSaved: true
                });
            });
        };

        const createOrUpdateHistory = () => {
            banksHistory.doc(`year${selectedYear}`).get().then(shot => {
                if (shot.exists) {
                    if (shot.data()[selectedMnth]) {
                        // console.log(`Selected Month exists.`);
                        
                        currentTimeStamp = new Date();
                        updateSelectedMonthsHistory(currentTimeStamp); // Update selected month's history record.
                        // console.log("Update selected month's history record.");

                    } else {
                        // console.log(`Selected Month doesn't exists.`);

                        currentTimeStamp = new Date();
                        createNewMonthsHistory(currentTimeStamp); // Create new month's history record.
                        // console.log(`Create new month's history record.`);
                        
                    }
                } else {
                    // console.log('year doesnt exists');

                    currentTimeStamp = new Date();
                    createNewYearsHistory(currentTimeStamp); // Create new year's history record.
                    // console.log(`Create new year's history record.`);

                }
            });
        };




        const updateSelectedBank = (latestTotalAmount) => {
            uidBanks.update({
                [`${selectedBank}.recordId`]: uuid,
                [`${selectedBank}.lastFundsAmount`]: fundsAmount,
                [`${selectedBank}.lastFundsProvider`]: fundsProvider,
                [`${selectedBank}.lastFundsDate`]: fundsDateVal,
                [`${selectedBank}.lastFundsTimeStamp`]: timeStamp,
                [`${selectedBank}.totalAmount`]: latestTotalAmount
            })
            .then(() => {
                createOrUpdateHistory();
            });
        };

        const createNewBank = () => {
            uidBanks.update({
                [`${selectedBank}`] : {
                    recordId: uuid,
                    lastFundsAmount: fundsAmount,
                    lastFundsProvider: fundsProvider,
                    lastFundsDate: fundsDateVal,
                    lastFundsTimeStamp: timeStamp,
                    totalAmount: fundsAmount
                }
            })
            .then(() => {
                createOrUpdateHistory();
            });
        };

        const createNewBankDoc = () => {
            uidBanks.set({
                [`${selectedBank}`]: {
                    recordId: uuid,
                    lastFundsAmount: fundsAmount,
                    lastFundsProvider: fundsProvider,
                    lastFundsDate: fundsDateVal,
                    lastFundsTimeStamp: timeStamp,
                    totalAmount: fundsAmount
                }
            })
            .then(() => {
                currentTimeStamp = new Date();
                createNewYearsHistory(currentTimeStamp); // Create new year's history record.
                // console.log(`Create new year's history record.`);
            });
        };



        // Get uidBanks
        uidBanks.get().then(querySnapShot => {

            // Check if data exists
            if (querySnapShot.exists) {
                // console.log('data exists');

                if (querySnapShot.data()[`${selectedBank}`]) {
                    // console.log('selected bank exists');

                    lastTotalAmount = querySnapShot.data()[`${selectedBank}`].totalAmount;
                    latestTotalAmount = lastTotalAmount + fundsAmount;

                    // Update data for totalAmount in local state.
                    BankStore.update(data => {
                        data[`${selectedBank}`].totalAmount = latestTotalAmount;
                        return data;
                    });

                    updateSelectedBank(latestTotalAmount); // Update selected bank's latest info record.
                    // console.log(`Update selected bank's latest info record`);

                } else {
                    // console.log('selected bank doesnt exists');

                    // Update local state with new bank record.
                    BankStore.update(data => {
                        data[`${selectedBank}`] = {
                            recordId: uuid,
                            lastFundsAmount: fundsAmount,
                            lastFundsProvider: fundsProvider,
                            lastFundsDate: fundsDateVal,
                            lastFundsTimeStamp: timeStamp,
                            totalAmount: fundsAmount
                        }
                        return data;
                    });

                    createNewBank(); // Create new bank's latest info record.
                    // console.log(`Create new bank's latest info record`);
                    
                }
                
            } else { // Initialize data records. This happens at the very begining of the app history.
                // console.log('data doesnt exists');

                // Set new data to local state.
                BankStore.set({
                    [`${selectedBank}`]: {
                        recordId: uuid,
                        lastFundsAmount: fundsAmount,
                        lastFundsProvider: fundsProvider,
                        lastFundsDate: fundsDateVal,
                        lastFundsTimeStamp: timeStamp,
                        totalAmount: fundsAmount
                    }
                });

                // Create new bank doc & new bank record inside it.
                createNewBankDoc();

            }

        });
 
    });
    
};

const validateData = (data) => {
    let { fundsAmount, fundsProvider, fundsDate, selectedBank} = data;

    return new Promise((resolve, reject) => {

        if ( fundsAmount == undefined ) {
            reject({
                msg: 'funds amount is required',
                field: 'amountEmpty'
            })
        }

        if ( fundsProvider == undefined ) {
            reject({
                msg: 'funds provider is required',
                field: 'providerEmpty'
            })
        }

        if ( fundsDate == undefined ) {
            reject({
                msg: 'funds date is required',
                field: 'dateEmpty'
            })
        }

        if ( selectedBank == undefined ) {
            reject({
                msg: 'selectedBank is required',
                field: 'bankEmpty'
            })
        } else {
            resolve({
                validation: true
            });
        }

    });
};

export { handleFunds, validateData };